module.exports = __webpack_public_path__ + "img/homelunbobeijing.1c2e29a5.png";